module.exports = __webpack_public_path__ + "img/bottom-gear-A-high_124x124.9dc9a001.png";